module.exports = __webpack_public_path__ + "img/box2.f0db015d.png";